module.exports = __webpack_public_path__ + "static/why_trident-b6a7ee3e544e78398e68623545b45479.jpg";